import React, { SVGProps, useId } from "react";
export const StormIcon = (props: SVGProps<SVGSVGElement>) => {
  const a = useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      viewBox="0 0 128 128"
      {...props}
    >
      <path
        fill="#feca18"
        d="m78 67.82-22.83 3.97s-7.6 19.36-8.07 20.67-.45 3.38 1.62 3.38c2.63 0 15.98-.07 15.98-.07s-3.24 15.63-3.43 17.03 1.31 2.63 2.63 1.22 19.51-24.79 20.3-25.93c1.41-2.04.05-3.92-1.55-4.01-1.6-.09-12.32.14-12.32.14L78 67.82z"
      />
      <path
        fill="#fdb900"
        d="M71.92 70.54s-5.09 11.26-5.28 11.9c-.56 1.9 1.9 2.67 2.6 1.13.7-1.55 6.76-14.08 6.76-14.08l-4.08 1.05zM49.99 92.17c1.34-.04 13.1-.07 14.08-.14 1.83-.14 2.11 2.39 0 2.39-2.19 0-13.73.04-14.43.07-1.62.08-1.84-2.25.35-2.32z"
      />
      <path
        fill="#ffe36a"
        d="M59.42 69.01s-6 15.06-6.34 16.19c-1.41 4.72 3.66 4.58 5 1.9.66-1.33 7.11-14.99 7.39-17.46.28-2.46-6.05-.63-6.05-.63zM61.01 86.57c-.86-.59-1.9-.07-2.53.92-.63.99-1.55 2.6-.14 3.45 1.27.76 2.39-.77 2.89-1.48.49-.71 1.12-1.98-.22-2.89zM71.34 89.8c-2.29-.49-3.03 1.41-3.52 3.66-.49 2.25-2.33 9.53-2.67 11.33-.49 2.53 1.83 2.89 2.82.56.74-1.74 3.95-9.59 4.36-10.84.63-1.89 1.33-4.21-.99-4.71z"
      />
      <path
        fill="#e4eaee"
        d="M107.92 46.26s2.6-34.98-27.31-39.42C53.72 2.85 48.44 28.38 48.44 28.38s-10.16-2.37-17.46 4.15c-7.25 6.48-6.69 14.15-6.69 14.15S6.41 43.86 4.58 59.21C2.87 73.55 24.01 69.98 24.01 69.98l100.38-7.39s2.38-7.54-5.21-13.23c-4.51-3.39-11.26-3.1-11.26-3.1z"
      />
      <radialGradient
        id={a}
        cx={65.811}
        cy={75.277}
        r={29.434}
        fx={52.634}
        fy={75.403}
        gradientTransform="matrix(.0288 -.9996 1.4975 .0432 -48.813 137.809)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.193} stopColor="#ffe366" />
        <stop offset={0.331} stopColor="#eddd82" />
        <stop offset={0.571} stopColor="#d0d4ad" />
        <stop offset={0.759} stopColor="#bfcfc7" />
        <stop offset={0.87} stopColor="#b8cdd1" />
      </radialGradient>
      <path
        fill={`url(#${a})`}
        d="M53.81 54.19c.84-.28 5.63 3.81 19.43 3.94 18.96.19 33.32-10.98 33.32-10.98s.48 3.4-1.03 5.82c-1.88 3-4.79 3.57-4.79 3.57s5.26 3.66 12.48 3.1c6.51-.51 11.22-2.72 11.22-2.72s.63 3.21.28 6.34c-.7 6.24-4.36 8.78-8.4 9.24-2.97.34-28.34.46-38.76.56-9.39.09-57.24 1.29-62.13.75-5.07-.56-8.92-3.61-10.32-7.98-1.07-3.31-.56-5.44-.56-5.44s9.32 2.47 14.55 1.88c6.57-.75 10.98-4.88 10.98-4.88s3.94 2.25 12.67 1.5c7.51-.66 11.06-4.7 11.06-4.7z"
      />
      <path
        fill="#52c0ee"
        d="M103.9 74.2c-1.02-.57-4.65 2.82-6.69 4.86-1.25 1.25-5.23 4.52-5.77 7.67-1.34 7.74 7.53 9.5 11.05 5.91 2.66-2.71 2.18-8 2.18-9.78.01-2.47.5-7.96-.77-8.66zM31.02 78.36c-.97-.56-4.45 2.72-6.41 4.71-1.2 1.21-5.01 4.38-5.55 7.46-1.32 7.55 7.13 9.32 10.51 5.84 2.55-2.63 2.13-7.8 2.14-9.54.01-2.41.51-7.77-.69-8.47zM47.15 100.74c-1.09-.41-4.76 2.93-6.8 4.97-1.25 1.25-4.95 4.45-5.49 7.6-1.34 7.74 7.25 9.57 10.77 5.98 2.66-2.71 2.22-8 2.18-9.78-.1-4.64.09-8.49-.66-8.77z"
      />
      <path
        fill="#b2e6fe"
        d="M97.78 84.22c-1.4-.73-3.1-.42-4.18 1.83-1.08 2.25-.19 4.04.94 4.55 1.3.6 2.91.05 3.99-1.78s.42-3.99-.75-4.6zM40.01 110.93c-1.44-.5-3.02.03-3.74 2.34-.72 2.31.39 3.89 1.54 4.23 1.33.39 2.79-.36 3.57-2.27.77-1.91-.17-3.88-1.37-4.3zM24.07 87.97c-1.52-.42-3.12.23-3.7 2.66-.58 2.43.66 3.99 1.87 4.25 1.4.31 2.85-.56 3.53-2.58.67-2-.42-3.98-1.7-4.33z"
      />
    </svg>
  );
};
